import { AxiosResponse } from 'axios';

import { API_ROUTES } from '@/constants';
import { List, CreditUnionRow, ReportSaveMode } from '@/types';

import { apiServices } from './services';

const { coreApiService } = apiServices;

export const getReport = async (
  offset: number,
  itemsPerPage: number,
  mode: ReportSaveMode | null,
): Promise<AxiosResponse<List>> => {
  const saveMode = mode ? `&saveMode=${encodeURIComponent(mode)}` : '';
  return coreApiService.get(
    `${API_ROUTES.REPORT}?StartRecord=${encodeURIComponent(offset)}&Count=${encodeURIComponent(itemsPerPage)}${saveMode}`,
  );
};

export const deleteReport = async (reportId: number) => coreApiService.delete(`${API_ROUTES.REPORT}/${reportId}`);
export const getCuReportById = async (reportId: number): Promise<AxiosResponse<CreditUnionRow[]>> =>
  coreApiService.get(API_ROUTES.GET_CU_REPORT_BY_ID(reportId));
export const sendRequest = async (reportId: number): Promise<AxiosResponse<{ isSuccess: boolean }>> =>
  coreApiService.post(`${API_ROUTES.REPORT}/${reportId}`);
